import React from 'react';

/**
 * Skeleton placeholder block. Shimmer is a transform-only highlight bar
 * (GPU-accelerated, no main-thread layout/paint cost). Per Emil:
 * "Only animate transform and opacity" — animating background-position
 * triggers paint on every frame.
 *
 * Uses `--ease-in-out` for the shimmer because it's continuous motion
 * rather than entering/exiting. Honors prefers-reduced-motion via the
 * global rule in index.css.
 *
 * Props:
 *   className — Tailwind sizing/positioning ("h-4 w-32", "h-12 w-full", etc.)
 *   rounded   — Tailwind radius class (default "rounded-md")
 */
export function Skeleton({ className = '', rounded = 'rounded-md', style }) {
    return (
        <div
            aria-hidden="true"
            className={`skeleton-block ${rounded} ${className}`}
            style={style}
        />
    );
}

/** Stack of skeleton lines — handy for paragraph-shaped placeholders. */
export function SkeletonLines({ count = 3, className = '' }) {
    return (
        <div className={`space-y-2 ${className}`}>
            {Array.from({ length: count }).map((_, i) => (
                <Skeleton
                    key={i}
                    className={`h-3 ${i === count - 1 ? 'w-2/3' : 'w-full'}`}
                />
            ))}
        </div>
    );
}
